import Axios from 'axios';
import { APP_SECRET_KEY } from '../constants';
import CryptoJS from 'crypto-js';

export const API_BASE_URL = 'https://cvgcoops.com.ng/api/v1'; 

export const baseUrlNoAuth = Axios.create({
  baseURL: `${API_BASE_URL}/`,
  headers: { 'Content-Type': 'application/json' },
});

export const baseUrlWithAuth = Axios.create({
  baseURL: `${API_BASE_URL}/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// export const virtualAccountBaseUrl = Axios.create({
//   baseURL: 'https://zippyworld.net/zippy_event_third_party/v1/api',
//   headers: {
//     'x-api-key': '6128892',
//     'Content-Type': 'application/json',
//   },
// });

const isDevelopment = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    hostname.endsWith('.local')
  );
};

const getPartnerSubdomain = (forcedSubdomain = null) => {
  if (forcedSubdomain) {
    return forcedSubdomain;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const partnerParam = urlParams.get('partner') || urlParams.get('subdomain');
  if (partnerParam) {
    return partnerParam;
  }

  if (isDevelopment()) {
    const savedPartner = localStorage.getItem('dev_partner_subdomain');
    if (savedPartner) {
      return savedPartner;
    }
  }

  const hostname = window.location.hostname;
  if (
    hostname.includes('.cloudvantage.com.ng') &&
    hostname.includes('.staging') &&
    hostname !== 'cloudvantage.com.ng' &&
    hostname !== 'staging.cloudvantage.com.ng'
  ) {
    return hostname.split('.')[0];
  }

  return null;
};

const addPartnerDomainParam = (url, subdomain) => {
  if (!subdomain) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}partner_domain=${subdomain}`;
};

const createPartnerAxiosInstance = (baseURL) => {
  const instance = Axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.request.use(
    (config) => {
      try {
        const decryptedData = CryptoJS.AES.decrypt(
          sessionStorage.getItem('userSessionData'),
          APP_SECRET_KEY,
        ).toString(CryptoJS.enc.Utf8);
        const parsedData = JSON.parse(decryptedData);
        const accessKey = parsedData.access;
        if (accessKey) {
          config.headers['Authorization'] = `Bearer ${accessKey}`;
        }

        if (config.data instanceof FormData) {
          delete config.headers['Content-Type'];
        }

        const subdomain = getPartnerSubdomain();
        if (subdomain) {
          config.url = addPartnerDomainParam(config.url, subdomain);
        }
      } catch (error) {
        console.error('Error in request interceptor:', error);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        sessionStorage.removeItem('userSessionData'); 
        window.location.href = '/';
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export const getPartnerAxiosInstance = (subdomain = null) => {
  const detectedSubdomain = getPartnerSubdomain(subdomain);

  if (detectedSubdomain) {
    // const partnerBaseURL = `https://${subdomain}.cvgcoops.com.ng/api/v1`;
    const partnerBaseURL = API_BASE_URL;
    return createPartnerAxiosInstance(partnerBaseURL);
  }

  return baseUrlWithAuth;
};

export const setDevelopmentPartner = (subdomain) => {
  if (isDevelopment()) {
    if (subdomain) {
      localStorage.setItem('dev_partner_subdomain', subdomain);
      
    } else {
      localStorage.removeItem('dev_partner_subdomain');
      
    }
  } else {
    console.warn('setDevelopmentPartner only works in development environment');
  }
};

export const debugPartnerConfig = () => {
  const subdomain = getPartnerSubdomain();
  const config = {
    isDevelopment: isDevelopment(),
    hostname: window.location.hostname,
    urlParams: Object.fromEntries(new URLSearchParams(window.location.search)),
    detectedSubdomain: subdomain,
    savedDevPartner: localStorage.getItem('dev_partner_subdomain'),
    willUsePartnerAPI: !!subdomain,
  };

  console.table(config);
  return config;
};

baseUrlNoAuth.interceptors.request.use(
  (config) => {
    try {
      const subdomain = getPartnerSubdomain();
      if (
        subdomain &&
        (window.location.search.includes('partner=') ||
          window.location.search.includes('subdomain=') ||
          (isDevelopment() && localStorage.getItem('dev_partner_subdomain')))
      ) {
        config.url = addPartnerDomainParam(config.url, subdomain);
      }
    } catch (error) {
      console.error('Error in baseUrlNoAuth request interceptor:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

baseUrlWithAuth.interceptors.request.use(
  (config) => {
    try {
      const decryptedData = CryptoJS.AES.decrypt(
        sessionStorage.getItem('userSessionData'),
        APP_SECRET_KEY,
      ).toString(CryptoJS.enc.Utf8);
      const parsedData = JSON.parse(decryptedData);
      const accessKey = parsedData.access;
      if (accessKey) {
        config.headers['Authorization'] = `Bearer ${accessKey}`;
      }

      if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
        
      }

      const subdomain = getPartnerSubdomain();
      if (
        subdomain &&
        (window.location.search.includes('partner=') ||
          window.location.search.includes('subdomain=') ||
          (isDevelopment() && localStorage.getItem('dev_partner_subdomain')))
      ) {
        config.url = addPartnerDomainParam(config.url, subdomain);
      }
    } catch (error) {
      console.error('Error in request interceptor:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

baseUrlWithAuth.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      sessionStorage.removeItem('userSessionData');
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);
